import { useState } from "react";
import { Toaster, toast } from "sonner";
import { Check } from "lucide-react";
import api from "@/lib/api";
import { useAuth, formatApiError } from "@/contexts/AuthContext";
import VipMembershipHero from "@/components/VipMembershipHero";

export default function VipPage() {
  const { user, refresh } = useAuth();
  const [vipSubmitting, setVipSubmitting] = useState(false);
  const [vipTicket, setVipTicket] = useState(null);
  const [thankYouOpen, setThankYouOpen] = useState(false);

  const subscribeVip = async (name, email) => {
    setVipSubmitting(true);
    try {
      const { data } = await api.post("/vip/subscribe", { email, name });
      setVipTicket(data.vip_ticket);
      toast.success("VIP ticket issued.");
      await refresh?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setVipSubmitting(false);
    }
  };

  return (
    <div data-testid="vip-page" className="bg-[#0a0a0a] min-h-screen">
      <VipMembershipHero
        vipTicket={user?.vip_ticket || vipTicket}
        onSubmit={subscribeVip}
        submitting={vipSubmitting}
        onThankYou={() => setThankYouOpen(true)}
      />

      {thankYouOpen && (
        <div
          data-testid="vip-thankyou-modal"
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
        >
          <div
            className="absolute inset-0 bg-black/70 backdrop-blur-md"
            onClick={() => setThankYouOpen(false)}
          />
          <div className="relative bg-[#0f0f0f] text-white border border-white/10 max-w-[500px] w-full p-10 text-center">
            <div className="mx-auto w-14 h-14 rounded-full bg-[#c9a84c] flex items-center justify-center">
              <Check size={22} strokeWidth={2} className="text-black" />
            </div>
            <h3 className="mt-6 font-serif text-3xl">Thank you.</h3>
            <p className="mt-3 text-sm text-white/70 leading-relaxed">
              Your details have been sent to our atelier team. A welcome
              email is on its way to your inbox.
              <span className="block mt-3 font-serif text-lg text-[#c9a84c] tracking-widest">
                {user?.vip_ticket || vipTicket || "VIP-ISSUED"}
              </span>
            </p>
            <button
              onClick={() => setThankYouOpen(false)}
              data-testid="vip-thankyou-close"
              className="mt-8 w-full bg-white text-black py-3.5 text-[11px] tracking-[0.28em] uppercase hover:bg-[#c9a84c]"
            >
              Continue
            </button>
          </div>
        </div>
      )}

      <Toaster theme="dark" position="top-center" />
    </div>
  );
}
